import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {MeteringRecord} from '../types';

export const EditPageNavigation = ({component}: { component: MeteringRecord }) => {

    const breadcrumbs = [{
        title: 'Home',
        href: '/dashboard',
    },
        {
            title: 'Metering Records',
            href: `/metering-records`,
        },
        {title: component.id}].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
